export const TEST_ID = 'onboardingCurrentUserPage';

export const FIRST_NAME_FIELD_NAME = 'firstName';

export const LAST_NAME_FIELD_NAME = 'lastName';

export const PHONE_FIELD_NAME = 'phone';

export const IN_PROGRESS = 'inProgress';

export const COMPLETED = 'completed';

export const PENDING = 'pending';
